export default function omit<T extends Object, K extends keyof T>(keys: K[], obj: T): Omit<T, K> {
  const clone = { ...obj };

  keys.forEach((key) => {
    delete clone[key];
  });

  return clone;
}
